(function ($) {
    $(document).ready(function () {
        cennikSliders();
        scrollTop();
        smoothScroll();
        fixedNav();
    });
    $(window).load(function () {
        realizacjeSliders();
    });
     function smoothScroll() {
        $('a[href*="#"]:not([href="#"]):not(.no-scroll)').click(function() {
            if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
                if (target.length) {
                    $('html, body').animate({
                        scrollTop: target.offset().top - 51
                    }, 1000);
                    return false;
                }
            }
        });
    }
    function fixedNav() {
        var offset = $('header nav').offset();
        var scrollTop = offset.top;
        $('.menu-toggle').click(function() {
            $('.fixed-nav .menu').slideToggle();
        });

        $(window).scroll(function() {
            if ( $(window).scrollTop() >= scrollTop ) {
                $('.fixed-nav').addClass('fixed');
            }else{
                $('.fixed-nav').removeClass('fixed');
            }

        });
        $('body').scrollspy({
            target: '.fixed-nav',
            offset: 51
        });
        $('.fixed-nav ul li a').click(function() {
            $('.fixed-nav .menu-toggle:visible').click();
        });
    }
    function scrollTop(){

        var scrollTop = $('header').height();
        $(window).scroll(function() {
            if ( $(window).scrollTop() >= scrollTop ) {
                $('.scroll-top').addClass('visible');
            }else{
                $('.scroll-top').removeClass('visible');
            }

        });
    }
    function cennikSliders() {
        $('.cennik-subpages').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            asNavFor: '.cennik-pages',
            dots: false,
            centerMode: true,
            arrows: false,
            focusOnSelect: true
        });

        $('.cennik-pages').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            asNavFor: '.cennik-subpages',
            dots: false,
            arrows: false,
            // centerMode: false,
            infinite: false,
        });

        $('.cennik-pages').on('beforeChange', function(event, slick, currentSlide, nextSlide){
            $('.cennik-subpages .subpage-title').removeClass('slick-current');
            $($('.cennik-subpages .subpage-title')[nextSlide]).addClass('slick-current');
        });
    }
    function realizacjeSliders() {
        $('.realizacje-slider').slick({
            variableWidth: true,
            centerMode: true,
            // prevArrow: $('.prev-arrow'),
            // nextArrow: $('.next-arrow'),
            arrows: false,
            slidesToScroll: 1,
            // responsive: [

            //     {
            //       breakpoint: 992,
            //       settings: {
            //         variableWidth: false,
            //         centerMode:false,
            //         slidesToShow:1,
            //         infinite: true,

            //       }
            //     },
            //     {
            //       breakpoint: 768,
            //       settings: {
            //         variableWidth: false,
            //         centerMode:false,
            //         slidesToShow:1,
            //         infinite: true,

            //       }
            //     },

            // ]
        });
        var slidersHeight;
        function setContainerHeight(){
            slidersHeight = parseInt(getComputedStyle(document.querySelector('.realizacje-slider.active-slider')).height);
            $('#sliders').height(slidersHeight);
        }

        $('#realizacje .slider-nav a').click(function(e) {
            e.preventDefault();

            $('#realizacje .slider-nav li').removeClass('active');
            $(this).parent().addClass('active');
            $('#sliders').find('.realizacje-slider').removeClass('active-slider');
            $('#sliders').find($(this).attr('href')).addClass('active-slider');
            setContainerHeight();

        });
        $('.prev-arrow').click(function(){
            $(".realizacje-slider.active-slider").slick('slickPrev');
        });
        $('.next-arrow').click(function(){
            $(".realizacje-slider.active-slider").slick('slickNext');
        });
        setContainerHeight();

        $(window).resize(function() {
             setContainerHeight();
        });
    }
})(jQuery);
